import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {Engine} from '../../models/engine/engine.model';
import {EngineState} from '../../state/engine.state';

@Pipe({
  standalone: false,
  name: 'engine'
})
export class EngineResolvePipe implements PipeTransform {
  private readonly engines: Engine[];

  constructor(private store: Store) {
    this.engines = this.store.selectSnapshot(EngineState.engines);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.engines?.length === 0) {
      return null;
    }
    const engine = this.engines.find(c => c.id === value);
    if (engine) {
      return engine.make + ' - ' + engine.model;
    }
    return null;
  }

}
